<h3 class="text-overflow">
    {{ item.UniqueRegistrationNumber }} <span ng-bind-html="item.Title|cHighlight:highlight"></span>
</h3>
